import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import TemRegDetailsTable from "./TemRegDetailsTable";
import DropDown from "../../Reports/DummyReportPage/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

const TemRegDetailsReports = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setNoTimeSet,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [resultsData, setResultsData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const fetchResultsData = async () => {
    if (!selectedCourseId) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Please select a course to view the report.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsApplied(false);
      return;
    }

    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);

    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 10000);

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-temporary-student-list-by-course/?course_id=${selectedCourseId}`
      );
      const data = await response.json();

      clearTimeout(slowLoadingTimer);

      if (data.status === 200 && data.message === "Success") {
        if (!Array.isArray(data.data) || data.data.length === 0) {
          setIsLoading(false);
          setNoTimeSet(false);
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                  No data found for the selected course.
                </span>
              </div>
            </div>
          );
          setActiveImg(false);
        } else {
          const rawHeaders = data.data.filter((item) => typeof item === "string");
          const parsedHeaders = rawHeaders.map((h) => h.split("*")[1]);
          const rows = data.data.filter((item) => Array.isArray(item));

          setHeaders(parsedHeaders);
          setResultsData(rows);

          setIsLoading(false);
          setNoTimeSet(false);
          setIsMessageBoxVisible(false);
        }
      } else if (data.status === 404) {
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                {data.message || "No results found for the selected course."}
              </span>
            </div>
          </div>
        );
        setActiveImg(false);
      } else {
        setIsLoading(false);
        setNoTimeSet(false);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span style={{ marginLeft: "10px", marginTop: "3px" }}>
                Something went wrong. Please try again.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
      }
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Error: {error.message}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  const handleApplyOrReset = () => {
    if (isApplied) {
      setIsApplied(false);
      setIsLoading(false);
      setResultsData([]);
      setHeaders([]);
      setIsColumnDivVisible(false);
      setIsMessageBoxVisible(false);
      setNoTimeSet(false);
    } else {
      setIsApplied(true);
      fetchResultsData();
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            Temporary Registration Details
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              onClick={() => navigate("/report_management")}
            >
              CANCEL
            </button>
            <button
              className="testreportcard-create-btn"
              onClick={() => {
                if (isLoading) return;
                handleApplyOrReset();
              }}
              style={{
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View, create, or filter reports. View and manage the list of reports
          already available or create a new report.
        </p>

        <div
          style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}
        >
          <div className="row-cs-uni">
            <div
              className="col-cs2"
              style={{ marginRight: "1vw", ...dropdownStyle }}
            >
              <DropDown
                label="Course"
                selected={selectedCourseId}
                setSelected={(selectedOption) => {
                  setSelectedCourseId(selectedOption);
                }}
                options={
                  coursesdata?.map((course) => ({
                    label: course.course_description,
                    id: course.course_id,
                  })) || []
                }
                isRequired="true"
              />
            </div>
          </div>
        </div>

        <div style={{ position: "relative", marginTop: "20px" }}>
          <button
            style={{
              position: "absolute",
              top: "-1px",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1,
              width: "60px",
              height: "10px",
              backgroundColor: "white",
              border: "none",
            }}
            onClick={() => {
              setIsExpanded(!isExpanded);
              setIsVisible(!isVisible);
            }}
          >
            <p style={{ fontSize: "20px", color: "black" }}>...</p>
          </button>
          <TemRegDetailsTable
            headers={headers}
            data={resultsData}
            searchPlaceholder="Search by Student Name..."
            isColumnDivVisible={isColumnDivVisible}
            setIsColumnDivVisible={setIsColumnDivVisible}
            dataClient={dataClient}
            course={coursesdata?.find((c) => c.course_id === selectedCourseId)?.course_description || ""}
            ReportPageHeader="Temporary Student List"
            isExpanded={isExpanded}
          />
        </div>
      </div>
      <div></div>
    </div>
  );
};


export default TemRegDetailsReports;